import apiRequest from "src/utils/api-request";
import withApiPath from "src/utils/with-api-path";

export interface LatestTransactionSummary {
	id: number;
	status: string;
	type: string;
	transactionHash?: string;
	// Crypto the customer paid (denominated in `currency`).
	currency?: string;
	amount?: string;
	factAmount?: string;
	// USD equivalent of the paid amount.
	usdAmount?: string;
}

export interface AdminPayment {
	id: number;
	publicId: string;
	merchantId: number;
	merchantName: string;
	merchantUserEmail?: string;
	merchantUserName?: string;
	merchantOrderId: string;
	status: string;
	type: string;
	price: string;
	currency: string;
	customerEmail?: string;
	isTest: boolean;
	description?: string;
	redirectUrl: string;
	createdAt: string;
	updatedAt: string;
	expiresAt?: string;
	webhookSentAt?: string;
	latestTransaction?: LatestTransactionSummary;
}

export interface PaginatedPaymentsResponse {
	payments: AdminPayment[];
	totalCount: number;
	limit: number;
	offset: number;
}

export interface ListPaymentsParams {
	limit?: number;
	offset?: number;
	search?: string;
	status?: string;
	type?: string;
	merchantId?: number;
	currency?: string;
	isTest?: boolean;
}

const paymentProvider = {
	async listPayments(
		params: ListPaymentsParams = {},
	): Promise<PaginatedPaymentsResponse> {
		const response = await apiRequest.get(withApiPath("/payments"), {
			params: {
				limit: params.limit ?? 50,
				offset: params.offset ?? 0,
				search: params.search ?? "",
				status: params.status ?? "",
				type: params.type ?? "",
				merchantId: params.merchantId ?? "",
				currency: params.currency ?? "",
				isTest: typeof params.isTest === "boolean" ? String(params.isTest) : "",
			},
		});

		return response.data;
	},

	async getPaymentByPublicId(publicId: string): Promise<AdminPayment> {
		const response = await apiRequest.get(withApiPath(`/payments/${publicId}`));

		return response.data;
	},
};

export default paymentProvider;
